import styled, { css } from 'styled-components';
import { space, layout, typography, color, SpaceProps, LayoutProps, TypographyProps, ColorProps } from 'styled-system';
import { Link as RRLink } from 'react-router';
import AccessibleFocusButton from './AccessibleFocusButton';

type SSProps = SpaceProps & LayoutProps & TypographyProps & ColorProps;

export const RouterLink = styled(RRLink)<SSProps>`
    color: ${({ theme }) => theme.colors.link.text};
    text-decoration: underline;
    cursor: pointer;

    ${({ theme }) => css`
        &:hover,
        &:focus,
        &:active {
            color: ${theme.colors.link.hover.text};
        }
    `}

    ${space}
  ${layout}
  ${typography}
  ${color}
`;

export const Anchor = styled.a<SSProps>`
    color: ${({ theme }) => theme.colors.link.text};
    text-decoration: underline;
    cursor: pointer;

    ${({ theme }) => css`
        &:hover,
        &:focus,
        &:active {
            color: ${theme.colors.link.hover.text};
        }
    `}

    ${space}
  ${layout}
  ${typography}
  ${color}
`;

export const Button = styled(AccessibleFocusButton)<SSProps>`
    display: inline;
    color: ${({ theme }) => theme.colors.link.text};
    background-color: transparent;
    text-decoration: underline;
    line-height: inherit;
    border: none;
    box-shadow: none;
    padding: 0;
    cursor: pointer;

    ${({ theme }) => css`
        &:hover,
        &:focus,
        &:active {
            color: ${theme.colors.link.hover.text};
        }
    `}

    ${space}
  ${layout}
  ${typography}
  ${color}
`;
